import { render } from "./Privacy.vue?vue&type=template&id=01e42261&scoped=true"
import script from "./Privacy.vue?vue&type=script&lang=js"
export * from "./Privacy.vue?vue&type=script&lang=js"

import "./Privacy.vue?vue&type=style&index=0&id=01e42261&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-01e42261"

export default script